import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Shield, Lock, Eye, FileText, Cookie } from "lucide-react";
const PrivacyPolicy = () => {
  return <div className="min-h-screen flex flex-col">
    <Navigation />

    <main className="flex-1">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-primary/5 to-transparent pt-4 pb-4">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center space-y-4">
            {/* Removed the icon */}
            <h1 className="text-4xl md:text-5xl font-bold text-foreground">
              Privacy Policy
            </h1>
            <p className="text-lg text-muted-foreground">
              Effective Date: October 24, 2025
            </p>
            <p className="text-base text-muted-foreground max-w-2xl mx-auto">
              At RenewSantulan, we are committed to protecting your personal data and respecting your privacy.
              This Privacy Policy outlines how we collect, use, and safeguard your information.
            </p>
          </div>
        </div>
      </section>


      {/* Privacy Policy Content */}
      <section className="px-4 sm:px-6 py-8 sm:py-12">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto space-y-8">

            {/* Section 1 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <div className="flex items-start gap-4">

                <div className="flex-1 space-y-3">
                  <h2 className="text-2xl font-semibold text-foreground">
                    1. Information We Collect
                  </h2>
                  <p className="text-muted-foreground leading-relaxed">
                    We collect personal data that you provide to us directly, such as:
                  </p>
                  <ul className="space-y-2 ml-4">
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">
                        <strong className="text-foreground">Personal Identification Information:</strong> Name, email address, phone number, etc.
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">
                        <strong className="text-foreground">Health Information:</strong> Medical history, current health status, and related data provided during consultations.
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">
                        <strong className="text-foreground">Usage Data:</strong> Information about your interactions with our website and services.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Section 2 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <div className="flex items-start gap-4">

                <div className="flex-1 space-y-3">
                  <h2 className="text-2xl font-semibold text-foreground">
                    2. Purpose of Data Collection
                  </h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Your personal data is collected for the following purposes:
                  </p>
                  <ul className="space-y-2 ml-4">
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">To provide personalized health and wellness services.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">To communicate with you regarding consultations and services.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">To improve our website and services based on user feedback.</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Section 3 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <div className="flex items-start gap-4">

                <div className="flex-1 space-y-3">
                  <h2 className="text-2xl font-semibold text-foreground">
                    3. Data Processing and Storage
                  </h2>
                  <p className="text-muted-foreground leading-relaxed">
                    We process and store your personal data securely, ensuring it is:
                  </p>
                  <ul className="space-y-2 ml-4">
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">Lawfully collected and processed with utmost safety as possible.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">Used solely for the purposes stated above.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1.5">•</span>
                      <span className="text-muted-foreground">Retained only as long as necessary to fulfill the purposes for which it was collected.</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Section 4 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">
                4. Data Sharing and Disclosure
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                We do not share your personal data with third parties except in the following circumstances:
              </p>
              <ul className="space-y-2 ml-4">
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1.5">•</span>
                  <span className="text-muted-foreground">With your explicit consent.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1.5">•</span>
                  <span className="text-muted-foreground">As required by law or to protect our rights.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1.5">•</span>
                  <span className="text-muted-foreground">With service providers who assist us in delivering our services, under strict confidentiality agreements.</span>
                </li>
              </ul>
            </div>

            {/* Section 5 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">
                5. Your Rights
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                You have the right to:
              </p>
              <ul className="space-y-2 ml-4">
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1.5">•</span>
                  <span className="text-muted-foreground">Access your personal data.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1.5">•</span>
                  <span className="text-muted-foreground">Correct any inaccuracies in your data.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1.5">•</span>
                  <span className="text-muted-foreground">Withdraw your consent at any time.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-primary mt-1.5">•</span>
                  <span className="text-muted-foreground">Request the deletion of your data, subject to legal obligations.</span>
                </li>
              </ul>
              <p className="text-muted-foreground leading-relaxed pt-2">
                To exercise these rights, please contact us at{" "}
                <a href="mailto:renewsantulan@gmail.com" className="text-primary hover:underline">
                  renewsantulan@gmail.com
                </a>
              </p>
            </div>

            {/* Section 6 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">
                6. Data Security
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                We implement reasonable security measures to protect your personal data from unauthorized access,
                disclosure, alteration, and destruction.
              </p>
            </div>

            {/* Section 7 */}
            <div className="card-enhanced rounded-xl p-8 space-y-4">
              <h2 className="text-2xl font-semibold text-foreground">
                7. Changes to This Privacy Policy
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                We may update this Privacy Policy from time to time. Any changes will be posted on this page
                with an updated effective date.
              </p>
            </div>

            {/* Cookie Policy Section */}
            <div className="pt-8 sm:pt-12">
              <div className="text-center space-y-4 mb-8">
                
                <h2 className="text-3xl md:text-4xl font-bold text-foreground">
                  Cookie Policy
                </h2>
                <p className="text-lg text-muted-foreground">
                  Effective Date: October 24, 2025
                </p>
                <p className="text-base text-muted-foreground max-w-2xl mx-auto">
                  Our website uses cookies to enhance your user experience and analyze site usage.
                  By using our website, you consent to the use of cookies as described in this policy.
                </p>
              </div>

              <div className="space-y-8">
                {/* Cookie Section 1 */}
                <div className="card-enhanced rounded-xl p-8 space-y-4">
                  <h3 className="text-2xl font-semibold text-foreground">
                    1. What Are Cookies?
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Cookies are small text files stored on your device that help us improve your browsing experience by:
                  </p>
                  <ul className="space-y-2 ml-4">
                    <li className="flex items-start gap-2">
                      <span className="text-accent mt-1.5">•</span>
                      <span className="text-muted-foreground">Remembering your preferences.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-accent mt-1.5">•</span>
                      <span className="text-muted-foreground">Analyzing site traffic.</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-accent mt-1.5">•</span>
                      <span className="text-muted-foreground">Personalizing content and advertisements.</span>
                    </li>
                  </ul>
                </div>

                {/* Cookie Section 2 */}
                <div className="card-enhanced rounded-xl p-8 space-y-4">
                  <h3 className="text-2xl font-semibold text-foreground">
                    2. Types of Cookies We Use
                  </h3>
                  <ul className="space-y-3">
                    <li className="space-y-1">
                      <p className="font-semibold text-foreground">Essential Cookies:</p>
                      <p className="text-muted-foreground">Necessary for the basic functioning of our website.</p>
                    </li>
                    <li className="space-y-1">
                      <p className="font-semibold text-foreground">Performance Cookies:</p>
                      <p className="text-muted-foreground">Help us understand how visitors interact with our site.</p>
                    </li>
                    <li className="space-y-1">
                      <p className="font-semibold text-foreground">Functional Cookies:</p>
                      <p className="text-muted-foreground">Allow us to remember your preferences and settings.</p>
                    </li>
                  </ul>
                </div>

                {/* Cookie Section 3 */}
                <div className="card-enhanced rounded-xl p-8 space-y-4">
                  <h3 className="text-2xl font-semibold text-foreground">
                    3. Managing Cookies
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    You can manage your cookie preferences through your browser settings. However, disabling certain
                    cookies may affect your experience on our website.
                  </p>
                </div>

                {/* Cookie Section 4 */}
                <div className="card-enhanced rounded-xl p-8 space-y-4">
                  <h3 className="text-2xl font-semibold text-foreground">
                    4. Consent
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    By continuing to use our website, you consent to the use of cookies as outlined in this policy.
                  </p>
                </div>
              </div>
            </div>

            {/* Contact CTA */}
            <div className="card-enhanced rounded-xl p-8 text-center space-y-4 bg-gradient-to-br from-primary/5 to-accent/5">
              <h3 className="text-2xl font-semibold text-foreground">
                Questions About Our Privacy Policy?
              </h3>
              <p className="text-muted-foreground">
                If you have any questions or concerns about our privacy practices, please don't hesitate to reach out.
              </p>
              <a href="https://wa.me/919910961228" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium">
                Contact Us
              </a>
            </div>

          </div>
        </div>
      </section>
    </main>

    <Footer />
  </div>;
};
export default PrivacyPolicy;